import React from 'react';
import HighlightText from './HighlightText';
import CTAButton from './CTAButton';
import {FaArrowRight} from 'react-icons/fa';
import { TypeAnimation } from 'react-type-animation';




const CodeBlocks = ({position, heading, subHeading, ctaBtn1, ctaBtn2, codeBlock, backgroundGradient, codeColor }) => {
  return (
    <div className={`flex ${position} my-20 justify-between gap-10 `}>
        
        {/* Section 1 */}
        <div className='lg:w-[50%] flex flex-col gap-8'>
            {heading}
            <div className='text-richblack-300 font-bold '>
                {subHeading}
            </div>

            <div className='flex gap-7 mt-7'>
                <CTAButton active={ctaBtn1.active} linkto={ctaBtn1.linkto}>
                    <div className='flex flex-row items-center gap-2'>
                        {ctaBtn1.btnText}
                        <FaArrowRight/>
                    </div>
                </CTAButton>
                <CTAButton active={ctaBtn2.active} linkto={ctaBtn2.linkto}>
                    {ctaBtn2.btnText}
                </CTAButton>
            </div>
        </div>


        {/* Section 2 */}
        <div className='h-fit flex flex-row text-[14px] max-w-[600px] py-4 lg:w-[500px] relative bg-richblack-800/20 backdrop-opacity-10 border border-richblack-800 rounded-md'>
            {/* HW --> BG Gradient */}
            <div className={`absolute top-[-5%] left-[-10%] w-[350px] h-[250px] rounded-full 
            ${backgroundGradient} blur-[30px] opacity-10`}></div>

            {/* bg-gradient-to-r from-[#1FA2FF] via-[#12D8FA] to-[#A6FFCB] */}

            <div className='text-center flex flex-col w-[10%] text-richblack-400 font-inter font-bold'>
                <p>1</p>
                <p>2</p>
                <p>3</p>
                <p>4</p>
                <p>5</p>
                <p>6</p>
                <p>7</p>
                <p>8</p>
                <p>9</p>
                <p>10</p>
                <p>11</p>
            </div>

            <div className={`w-[90%] flex flex-col gap-2 font-bold font-mon ${codeColor}`}>
                <TypeAnimation
                    sequence={[codeBlock, 5000, ""]}
                    repeat={Infinity}
                    cursor={true}
                    omitDeletionAnimation={true}
                    style={
                        {
                            whiteSpace: "pre-line",
                            display: "block"
                        }
                    }
                />
            </div>


        </div>



    </div>
  )
}

export default CodeBlocks
